// Central content for SocialImpactCLE
export const BRAND = {
  name: "SocialImpactCLE",
  tagline: "Empowering Communities. Creating Impact. For Cleveland and Beyond.",
  logo: "https://static.prod-images.emergentagent.com/jobs/a1354158-fd8f-4d95-8fa2-e73c235982e8/images/d630758897483585d77d8d44f20388a50b6e375dbc249246efa11a26012b6d30.jpeg",
};

export const NAV_LINKS = [
  { label: "Home", href: "#home" },
  { label: "About", href: "#about" },
  { label: "Our Programs", href: "#programs" },
  { label: "Press", href: "#press" },
  { label: "Contact", href: "#contact" },
];

export const PROGRAMS = [
  {
    id: "striving-together",
    index: "01",
    title: "Striving Together: Thriving Together",
    accent: "#E8621A",
    icon: "PiggyBank",
    description:
      "Community members helping each other navigate the rising cost of living with practical, real-world cost-saving tips.",
    image:
      "https://images.unsplash.com/photo-1695938746747-ec185ea81325?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
    imageAlt: "A diverse group of community members gathered together",
  },
  {
    id: "recipe-remix",
    index: "02",
    title: "Recipe Re-Mix: Thrive Kitchen",
    accent: "#FF6B6B",
    icon: "UtensilsCrossed",
    description:
      "Keeping cultural food traditions alive through healthy, budget-friendly cooking. Add flavor, add nutrition — never sacrifice what you love.",
    image:
      "https://images.unsplash.com/photo-1590779033100-9f60a05a013d?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
    imageAlt: "Colorful fresh vegetables arranged for healthy cooking",
  },
  {
    id: "subsmatter",
    index: "03",
    title: "SubsMatter",
    accent: "#2A9D8F",
    icon: "BookOpen",
    description:
      "Empowering substitute teachers with the tools, resources, and preparation they need to walk into any classroom with confidence.",
    image:
      "https://images.unsplash.com/photo-1577896851231-70ef18881754?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
    imageAlt: "A teacher standing in front of students in a classroom",
  },
  {
    id: "sharing-sunshine",
    index: "04",
    title: "Sharing Sunshine",
    accent: "#F4A261",
    icon: "Sun",
    description:
      "A community feed where members share their daily acts of kindness. Earn badges, inspire others, and discover the science of giving.",
    image:
      "https://images.unsplash.com/photo-1582213782179-e0d53f98f2ca?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
    imageAlt: "Hands of many people stacked together in unity",
  },
  {
    id: "brain-recovery",
    index: "05",
    title: "Flavor, Freedom & Brain Recovery",
    accent: "#264653",
    icon: "Brain",
    description:
      "Supporting stroke survivors and caregivers through the power of diet and brain-healthy nutrition. Flavor and freedom are part of recovery.",
    image:
      "https://images.unsplash.com/photo-1613082410785-22292e8426e7?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
    imageAlt: "A bowl of fresh berries, a brain-healthy food",
    featured: true,
  },
];

export const STATS = [
  { label: "Communities Served", value: 24, suffix: "+", display: "24+" },
  { label: "Acts of Kindness", value: 15800, suffix: "+", display: "15,800+" },
  { label: "Recipes Remixed", value: 3250, suffix: "", display: "3,250" },
  { label: "Teachers Supported", value: 480, suffix: "+", display: "480+" },
];

export const PRESS = ["Cleveland Magazine", "Cleveland.com", "WVIZ / PBS"];

export const PRESS_QUOTE =
  "Susan Porter is changing how communities think about food, cost, and care.";

export const CITY_IMAGE =
  "https://images.unsplash.com/photo-1578009661061-f2ef694ebedb?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600";
